module.exports = __webpack_public_path__ + "static/media/30.5069ee94.ogg";